<template>
  <div>
    <div class="modal-backdrop fade show" style="z-index: 10000">
      <div class="row justify-content-center h-100">
        <div class="align-self-center">
          <RingLoader class="text-center" color="#fff" :size=100 />
          <h3 class="text-center text-light">Cargando...</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RingLoader } from "@saeris/vue-spinners";
export default {
  name: "Loading",
  components: {
    RingLoader,
  },
};
</script>
